import logoMaestria from "@/assets/brand/logo-maestria.svg";
import wordmarkMaestriaGold from "@/assets/brand/wordmark-maestria-gold.svg";
import logoAutou from "@/assets/brand/autou-vector.svg";
import iconOnline from "@/assets/icons/online.webp";
import iconMedal from "@/assets/icons/medal.webp";
import iconAiFirst1 from "@/assets/icons/ai-first-1.webp";
import iconAiFirst2 from "@/assets/icons/ai-first-2.webp";
import iconAiFirst3 from "@/assets/icons/ai-first-3.webp";
import iconGift from "@/assets/icons/gift.webp";
import iconRobozinho from "@/assets/icons/robozinho.webp";
import iconPeople from "@/assets/icons/people-masterclass.webp";
import iconMessage from "@/assets/icons/message.webp";
import heroVideo from "@/assets/photos/hero-video.webp";
import heroPortrait from "@/assets/photos/hero-portrait.webp";
import heroPortraitEdu from "@/assets/photos/hero-portrait-edu.webp";
import audience1 from "@/assets/photos/audience-1.webp";
import audience2 from "@/assets/photos/audience-2.webp";
import audience3 from "@/assets/photos/audience-3.webp";
import mentorLucas from "@/assets/photos/mentor-lucas.webp";
import mentorLucasBg from "@/assets/photos/mentor-lucas-bg.webp";
import mentorEduardo from "@/assets/photos/mentor-eduardo.webp";
import mentorEduardoBg from "@/assets/photos/mentor-eduardo-bg.webp";
import offerAgente from "@/assets/photos/offer-agente.webp";
import offerPlano from "@/assets/photos/offer-plano.webp";
import offerCollage1 from "@/assets/photos/offer-collage-1.webp";
import offerCollage2 from "@/assets/photos/offer-collage-2.webp";
import offerCollage3 from "@/assets/photos/offer-collage-3.webp";
import beforeAfter1 from "@/assets/photos/before-after-1.webp";
import beforeAfter2 from "@/assets/photos/before-after-2.webp";
import deliverablesAgent from "@/assets/photos/deliverables-agent.webp";
import rippedNotes from "@/assets/graphics/ripped-notes.png";
import signupSuccess from "@/assets/graphics/signup-success.webp";
import ticketTurma from "@/assets/graphics/ticket-turma.svg";
import ellipse1 from "@/assets/graphics/ellipse-1.svg";
import ellipse2 from "@/assets/graphics/ellipse-2.svg";
import ellipse3 from "@/assets/graphics/ellipse-3.svg";

export const MAESTRIA_ASSETS = {
  brand: {
    logo: logoMaestria,
    wordmarkGold: wordmarkMaestriaGold,
    autou: logoAutou,
  },
  icons: {
    online: iconOnline,
    medal: iconMedal,
    aiFirst1: iconAiFirst1,
    aiFirst2: iconAiFirst2,
    aiFirst3: iconAiFirst3,
    gift: iconGift,
    robozinho: iconRobozinho,
    people: iconPeople,
    message: iconMessage,
  },
  photos: {
    heroVideo,
    heroPortrait,
    heroPortraitEdu,
    audience1,
    audience2,
    audience3,
    mentorLucas,
    mentorLucasBg,
    mentorEduardo,
    mentorEduardoBg,
    offerAgente,
    offerPlano,
    offerCollage1,
    offerCollage2,
    offerCollage3,
    beforeAfter1,
    beforeAfter2,
    deliverablesAgent,
  },
  graphics: {
    rippedNotes,
    signupSuccess,
    ticketTurma,
    ellipse1,
    ellipse2,
    ellipse3,
  },
} as const;
